import React from "react";
import { LabelledCheckbox } from "@coverme/forms";
import { some } from "lodash-es";

export const CheckboxGroupWithValue = ({
    title,
    flexDirection = "column",
    changeEvent,
    groupName,
    items,
    required = true,
    selectedValues = [],
    validState,
    errorMessage,
}) => {
    const onChange = (item, element) => {
        const isChecked = element.target.checked;
        let newSelectedValues = [];
        if (isChecked) {
            newSelectedValues = [...selectedValues, item];
        } else {
            newSelectedValues = selectedValues.filter(x => x !== item);
        }

        changeEvent(element, newSelectedValues);
    };

    return (
        <fieldset className={`checkbox-group validation-container ${validState}`}>
            <div className="legend-container">
                <legend className={`checkbox-group__title h6 input-field__label ${required && "required"}`}>
                    {title}
                </legend>
            </div>
            <div className="checkbox-group__items" style={{ flexDirection: flexDirection }}>
                {items.map((item, index) => {
                    const isChecked = some(selectedValues, x => x.value === item.value);
                    return (
                        <LabelledCheckbox
                            key={groupName + index}
                            labelText={item.label}
                            id={groupName + "-checkbox-" + index}
                            groupName={groupName}
                            value={item.value}
                            checked={isChecked}
                            changeEvent={onChange.bind(this, item)}
                        />
                    );
                })}
            </div>
            {validState === "invalid" ? <span className="validation-message">{errorMessage}</span> : null}
        </fieldset>
    );
};
